import { render, staticRenderFns } from "./PedidosFormComponent.vue?vue&type=template&id=e1c53d16&"
import script from "./PedidosFormComponent.vue?vue&type=script&lang=js&"
export * from "./PedidosFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports